import { FormattedMessage, injectIntl } from "react-intl";

import { Formik } from "formik";
import PermissionEdit from "./PermissionEdit";
import UserGroupTypeahead from "../UserGroups/UserGroupTypeahead";
import { createPermissionKey } from "../../utils/permissionUtils";
import {
  DeleteActionButton,
  ActionBar,
  ActionBarButtons,
  CreateActionButton,
} from "../ActionBar";
import { Form, SubmitButton } from "../Form";

// @ts-expect-error TS(2724) FIXME: '"../../shapes"' has no exported member named 'use... Remove this comment to see the full error message
import { usersPermissionsShape, intlShape } from "../../shapes";
import * as browserUtils from "../../utils/browserUtils";

type Props = {
  allowedPermissions: $TSFixMe[]; // TODO: PropTypes.oneOf([ PermissionType.READ, PermissionType.UPDATE, PermissionType.DELETE, PermissionType.PERMIT, ])
  onPermissionCreate: $TSFixMeFunction;
  intl: intlShape;
  onPermissionDelete: $TSFixMeFunction;
  onDelete: $TSFixMeFunction;
  onAdd: $TSFixMeFunction;
  permitableId: number;
  permitableType: string;
  userGroupsPermissions: usersPermissionsShape;
};

function UserGroupPermissionsEdit({
  userGroupsPermissions,
  permitableId,
  permitableType,
  allowedPermissions,
  onPermissionCreate,
  onDelete,
  onPermissionDelete,
  onAdd,
  intl,
}: Props) {
  const renderUserGroupPermissions = (userGroupPermission: $TSFixMe) => {
    const renderedPermissionItems = allowedPermissions.map((permissionType) => {
      const key = createPermissionKey(
        permitableType,
        permitableId,
        "Usergroup",
        userGroupPermission.id,
        permissionType,
      );
      const permissionId = userGroupPermission[permissionType.substring(4)];
      return (
        <PermissionEdit
          key={key}
          onCreate={onPermissionCreate}
          onDelete={onPermissionDelete}
          permissionId={permissionId}
          assignableId={userGroupPermission.id}
          assignableType="Usergroup"
          permissionType={permissionType}
          permitableId={permitableId}
          // @ts-expect-error TS(2322) FIXME: Type '{ key: string; onCreate: $TSFixMeFunction; o... Remove this comment to see the full error message
          permitableType={permitableType}
        />
      );
    });

    return (
      <div
        key={userGroupPermission.id}
        className="permission-group-item"
        id="permission-user-items"
      >
        <div className="permission-assignee">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className="clickable"
            onClick={() =>
              browserUtils.navigateTo(`/usergroups/${userGroupPermission.id}`)
            }
          >
            {userGroupPermission.name}
          </div>
        </div>
        <div className="permission-items" id="permission-user-item">
          {renderedPermissionItems}
          <div className="permission-delete">
            <DeleteActionButton
              disabled={false}
              modalTitle={intl.formatMessage({
                id: "edit_permissions.delete.modal_title",
              })}
              modalMessage={intl.formatMessage(
                { id: "edit_permissions.delete.modal_message" },
                { name: userGroupPermission.name },
              )}
              onConfirm={() => onDelete(userGroupPermission.id, false)}
            />
          </div>
        </div>
      </div>
    );
  };

  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (values.usergroup?.id === undefined) {
      (errors as $TSFixMe).usergroup = intl.formatMessage({
        id: "validation.user_group.mandatory",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    const permissionItems = userGroupsPermissions.map((permissions: $TSFixMe) =>
      renderUserGroupPermissions(permissions),
    );
    return (
      <div id="edit-user-group-permissions" className="permission-group-items">
        <ActionBar>
          <h3>
            <FormattedMessage id="edit_permissions.user_groups" />
          </h3>
          <ActionBarButtons>
            <CreateActionButton
              // @ts-expect-error TS(2322) FIXME: Type '{ id: string; target: string; }' is not assi... Remove this comment to see the full error message
              id="create-user-group-button"
              target="/usergroups/create"
            />
          </ActionBarButtons>
        </ActionBar>
        {permissionItems}
        <Form id="edit-permissions-add-user-group" {...formProps}>
          <UserGroupTypeahead
            {...formProps}
            id="user-group"
            name="usergroup"
            label={intl.formatMessage({ id: "label.name" })}
            excludables={userGroupsPermissions}
          />
          <SubmitButton
            id="add-user-group-permission"
            text={intl.formatMessage({
              id: "edit_permissions.add_user_group_button",
            })}
            fetching={isSubmitting}
          />
        </Form>
      </div>
    );
  };

  return (
    <Formik validate={validateForm} onSubmit={onAdd} initialValues={{}}>
      {renderForm}
    </Formik>
  );
}

export default injectIntl(UserGroupPermissionsEdit);
